import React from "react";
import { useSelector } from "react-redux";
import { Container, Spacer } from "./ChartInterfaceToolbarStyles";
import Buttons from "./Buttons/Buttons";
import SavedPatterns from "../../ColdStart/SavedPatterns/SavedPatterns";
import SelectedPatterns from "./SelectedPatterns/SelectedPatterns";

export default function ChartInterfaceToolbar({ setLoading }) {
  // Select from redux store
  const { mode, branch } = useSelector(({ display }) => display);

  return (
    <Container>
      {mode === "drawModel" ? (
        <Spacer>
          Select at least one region to train model using the TradingView
          rectangle tool
        </Spacer>
      ) : (
        {
          selectPattern: <SelectedPatterns />,
          drawModel: <SavedPatterns />,
        }[branch]
      )}
      <Buttons drawModel={mode === "drawModel"} setLoading={setLoading} />
    </Container>
  );
}
